import { AdvisoryFee } from '../models';

export const CustomAdvisoryFee: AdvisoryFee = {
	defaultFee: 3,
	minimumFee: 0.01,
	maximumFee: 99
};
